import React from 'react';
import { Stack, Button, Theme } from '@mui/material';

import { TMenuOption } from 'shared/types/card.interface';
import { useAppDispatch } from 'redux/hooks/reduxHooks';
import { openAlertDialog } from 'redux/slices/modals/modals.slice';

interface CardMenuProps {
  cardMenuIsOpen: boolean;
  menuOptions: TMenuOption[];
}

const CardMenu: React.FC<CardMenuProps> = ({ cardMenuIsOpen, menuOptions }) => {
  const dispatch = useAppDispatch();
  if (menuOptions.length === 0) return null;

  return cardMenuIsOpen ? (
    <Stack
      sx={{
        position: 'absolute',
        top: 'calc(100% + 8px)',
        right: 0,
        width: 'max-content',
        borderRadius: '8px',
        backgroundColor: 'primary.contrastText',
        boxShadow: (theme: Theme) => `0 2px 24px 0 ${theme.palette.myShadow.menu}`,
        zIndex: 5,
      }}
    >
      {menuOptions.map((option, index) => (
        <Button
          key={index}
          variant="menu"
          className="cardMenuElement"
          onClick={() => dispatch(openAlertDialog(option.dialogInfo))}
          disableRipple
        >
          {option.name}
        </Button>
      ))}
    </Stack>
  ) : null;
};

export default CardMenu;
